import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box, TextField,
    Grid,
    DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { useData } from "../../../context/DataContext";
import SingleSelect from "../../../components/Selections/singleSelect";
import { updateTrainingSession } from '../../../context/createAPI';
import SnackbarMessage from "../../../components/snackBar/snackBar";
import CustomButton from "../../../components/buttons/customButton";
import { getClientTheme } from "../../../theme/clientTheme";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const TrainingSessionStatusUpdateModal = ({ show, handleClose, rowData, statusUpdate, updateDate }) => {
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    const { trainingStatus = [], user = [], handleTrainingSessions, user_client_id } = useData();
    const clientTheme = getClientTheme(user_client_id);

    const [state, setState] = useState({
        training_status: "",
        training_statusError: "",
        loading: false,
        trainingStatusOptions: [],
        schedule_date: "",
        schedule_date_error: "",
    });

    const handleInputChange = (name, value) => {
        setState((prevState) => ({
            ...prevState,
            [name]: value,
            training_statusError: "",
            schedule_date_error: "",
        }));
    };

    useEffect(() => {
        if (rowData) {
            const selectedStatus = trainingStatus.find((item) => item.value === rowData.training_Status_id);
            const nextOptionValue = selectedStatus ? selectedStatus.value + 1 : 1;
            const nextOption = trainingStatus.filter(option => option.value === nextOptionValue);

            setState((prevState) => ({
                ...prevState,
                training_status: nextOption[0]?.value ?? "",
                trainingStatusOptions: nextOption ?? []
            }));
        }
    }, [rowData, trainingStatus]);


    const handleSubmitStatus = async () => {
        let isValid = true;

        if (!state.training_status) {
            setState((prevState) => ({
                ...prevState,
                training_statusError: "Select Status",
            }));
            isValid = false;
        }

        if (!isValid) {
            return "";
        }
        setState((prevState) => ({ ...prevState, loading: true }));
        try {
            const params = {
                id: rowData?.id,
                attended_count: null,
                training_plan_id: null,
                level_id: null,
                session_date: null,
                ff_group_id: null,
                village_id: null,
                training_status_id: state.training_status,
                client_id: parseInt(localStorage.getItem("user_client_id")),
                feedback: null,
                training_session_photos: null,
                updated_by: user.user_id ? user.user_id : null
            };

            const createSession = await updateTrainingSession(params);

            if (createSession.statusCode === 200) {
                handleTrainingSessions();
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    responseMessage: createSession.message,
                }));

                setSnackbar({
                    open: true,
                    message: createSession.message,
                    severity: "success",
                });
                setTimeout(() => {
                    handleClose();
                }, 2000);
            }
        } catch (error) {
            console.error(error);
            setSnackbar({
                open: true,
                message: error,
                severity: "success",
            });
        }
    };

    const handleUpdateSessionDate = async () => {
        let isValid = true;
        const { schedule_date } = state;
        if (!schedule_date) {
            setState(prevState => ({ ...prevState, schedule_date_error: "Please Select Schedule Date" }));
            isValid = false;
        }

        if (!isValid) {
            return "";
        }

        setState((prevState) => ({ ...prevState, loading: true }));

        try {

            const params = {
                id: rowData?.id,
                training_plan_id: null,
                level_id: null,
                session_date: Math.floor(new Date(schedule_date).getTime() / 1000),
                ff_group_id: null,
                village_id: null,
                training_status_id: rowData?.training_Status_id ?? null,
                client_id: parseInt(localStorage.getItem("user_client_id")),
                feedback: null,
                training_session_photos: null,
                attended_count: null,
                updated_by: user.user_id ? user.user_id : null
            };

            const createSession = await updateTrainingSession(params);

            if (createSession.statusCode === 200) {
                handleTrainingSessions();
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    responseMessage: createSession.message,
                }));
                setTimeout(() => {
                    handleClose();
                }, 2000);

                setSnackbar({
                    open: true,
                    message: createSession.message,
                    severity: "success",
                });
            }

        } catch (error) {
            console.error(error);
            setSnackbar({
                open: true,
                message: error,
                severity: "success",
            });
        }
    }

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            TransitionComponent={Transition}
            fullWidth
            maxWidth="xs"
            keepMounted
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    backgroundColor: '#fdfdfd',
                    boxShadow: 6,
                    mt: 4,
                    alignSelf: 'flex-start',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    color: " #FFFFFF",
                    backgroundColor: clientTheme.activeBg,
                    boxShadow: "0px 3px 10px rgba(0,0,0,0.3)",
                    px: 3,
                    py: 1,
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                }}
            >
                <DialogTitle sx={{ m: 0, p: 0, fontSize: '1.2rem', textTransform: "uppercase", fontWeight: "bold" }}>{statusUpdate ? "Status Update" : "Update Session Date"}</DialogTitle>

                <IconButton onClick={() => handleClose()} sx={{ color: '#fff' }}>
                    <CloseIcon />
                </IconButton>
            </Box>


            <DialogContent dividers>
                {
                    [
                        ...statusUpdate ? [{ id: 1, name: "training_status", value: state.training_status, label: "Select Status", error: state.training_statusError, type: "select", options: state.trainingStatusOptions }] :
                            [{ id: 2, name: "schedule_date", error: state.schedule_date_error }]
                    ].map((field) => (
                        <Grid item size={{ xs: 12, md: 12 }}>
                            {
                                field.type === "select" ? (
                                    <SingleSelect
                                        name={field.name}
                                        label={field.label}
                                        options={field.options}
                                        value={field.value}
                                        onChange={handleInputChange}
                                        error={field.error}
                                        formHelperText={true}
                                        disabled
                                    />
                                ) : (
                                    <TextField
                                        fullWidth
                                        type="datetime-local"
                                        size="small"
                                        name="schedule_date"
                                        label={field.label}
                                        value={state.schedule_date}
                                        onChange={(e) => handleInputChange("schedule_date", e.target.value)}
                                        error={!!field.error}
                                        helperText={field.error}
                                        // inputProps={{
                                        //     min: getCurrentDateTime(),
                                        // }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )
                            }
                        </Grid>
                    ))
                }
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center" }}>
                {(statusUpdate
                    ? [
                        {
                            id: 1,
                            label: "Update Status",
                            status: state.loading ? "loading" : "idle",
                            onClick: handleSubmitStatus,
                        },
                    ]
                    : [
                        {
                            id: 2,
                            label: "Update Date",
                            status: state.loading ? "loading" : "idle",
                            onClick: handleUpdateSessionDate,
                        },
                    ]
                ).map((item) => (
                    <CustomButton
                        key={item.id}
                        status={item.status}
                        onClick={item.onClick}
                        label={item.label}
                        loadingLabel="Submitting.."
                    />
                ))}
            </DialogActions>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Dialog>
    );
};
export default TrainingSessionStatusUpdateModal;
